<template>
  <BootstrapAlert variant="secondary" class="flex-column" style="align-items: start !important">
    <div class="d-flex align-items-center mb-1">
      <Icon icon="material-symbols:error-outline" class="text-danger fs-5 me-2" />
      <h6 class="text-danger m-0">{{ translate('Network Error') }}</h6>
    </div>
    <p class="fw-light m-0 w-100">{{ errorMessage }}</p>
  </BootstrapAlert>
</template>
<script setup lang="ts">
const {translate} = useLocalisation();
defineProps<{errorMessage?: string}>();
</script>
